import React, { FC, ReactElement, useEffect, useState } from "react";
import { Box, useDarkMode } from "ui-components";
import useSession from "ui-io/use-session";
import styled from "styled-components";
import { Classes, TabId } from "@blueprintjs/core";

import { StyleSheetManager } from "styled-components";
import isPropValid from "@emotion/is-prop-valid";

import GlobalErrorBoundary from "ui-components/global-error-boundary";
import PageComponent from "ui-components/page-component";
import { useLocation, useNavigate } from "react-router-dom";
import AppHeader from "./app-header";

const Layout: FC<{ children: ReactElement }> = ({ children }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [darkMode] = useDarkMode();
  const { isAuthenticated } = useSession();
  const [tabValue, setTabValue] = useState<TabId>("dashboard");

  useEffect(() => {
    if (tabValue !== pathname)
      setTabValue(pathname.split("/")?.pop() as string);
  }, [pathname]);

  const handleTabChange = (tab: string | null) => {
    if (tab !== null) {
      setTabValue(tab);
      navigate(`/${tab}`);
    }
  };
  return (
    <StyleSheetManager shouldForwardProp={(prop) => isPropValid(prop)}>
      <StyledLayout className={darkMode ? Classes.DARK : ""}>
        <Box flexDir="row" height={"1"}>
          <AppHeader />
          <PageComponent fill padTop={0}>
            <StyledContents>
              <GlobalErrorBoundary>
                {children ? children : null}
              </GlobalErrorBoundary>
            </StyledContents>
          </PageComponent>
        </Box>
      </StyledLayout>
    </StyleSheetManager>
  );
};

export default Layout;

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const StyledContents = styled.main`
  padding: 40px;
  flex: 1 1;
  width: 100%;
  overflow: unset;
  margin-top: 40px;
  margin-bottom: 70px;
`;
